import { StateCreator } from 'zustand';

export interface DebugState {
  // Debug flags
  debugEnabled: boolean;
  debugAuth: boolean;
  debugAPI: boolean;
  debugBlog: boolean;
  debugDealer: boolean;
  debugCache: boolean;
  debugPricing: boolean;
  debugAdmin: boolean;
  debugCoin: boolean;
  debugFavorites: boolean;
  debugSSR: boolean;
  debugAudio: boolean;
  debugNotifications: boolean;
  
  // Actions
  setDebugEnabled: (enabled: boolean) => void;
  setDebugAuth: (enabled: boolean) => void;
  setDebugAPI: (enabled: boolean) => void;
  setDebugBlog: (enabled: boolean) => void;
  setDebugDealer: (enabled: boolean) => void;
  setDebugCache: (enabled: boolean) => void;
  setDebugPricing: (enabled: boolean) => void;
  setDebugAdmin: (enabled: boolean) => void;
  setDebugCoin: (enabled: boolean) => void;
  setDebugFavorites: (enabled: boolean) => void;
  setDebugSSR: (enabled: boolean) => void;
  setDebugAudio: (enabled: boolean) => void;
  setDebugNotifications: (enabled: boolean) => void;
  resetDebugSettings: () => void;
}

const DEFAULT_DEBUG_STATE = {
  debugEnabled: false,
  debugAuth: false,
  debugAPI: false,
  debugBlog: false,
  debugDealer: false,
  debugCache: false,
  debugPricing: false,
  debugAdmin: false,
  debugCoin: false,
  debugFavorites: false,
  debugSSR: false,
  debugAudio: false,
  debugNotifications: false,
};

export const createDebugSlice: StateCreator<DebugState> = (set) => ({
  ...DEFAULT_DEBUG_STATE,
  
  setDebugEnabled: (enabled) => set((state) => {
    // When disabling general debug, disable all categories
    if (!enabled) {
      return {
        ...state,
        debugEnabled: false,
        debugAuth: false,
        debugAPI: false,
        debugBlog: false,
        debugDealer: false,
        debugCache: false,
        debugPricing: false,
        debugAdmin: false,
        debugCoin: false,
        debugFavorites: false,
        debugSSR: false,
        debugAudio: false,
        debugNotifications: false,
      };
    }
    return { ...state, debugEnabled: enabled };
  }),
  
  setDebugAuth: (enabled) => set((state) => ({ ...state, debugAuth: enabled })),
  setDebugAPI: (enabled) => set((state) => ({ ...state, debugAPI: enabled })),
  setDebugBlog: (enabled) => set((state) => ({ ...state, debugBlog: enabled })),
  setDebugDealer: (enabled) => set((state) => ({ ...state, debugDealer: enabled })),
  setDebugCache: (enabled) => set((state) => ({ ...state, debugCache: enabled })),
  setDebugPricing: (enabled) => set((state) => ({ ...state, debugPricing: enabled })),
  setDebugAdmin: (enabled) => set((state) => ({ ...state, debugAdmin: enabled })),
  setDebugCoin: (enabled) => set((state) => ({ ...state, debugCoin: enabled })),
  setDebugFavorites: (enabled) => set((state) => ({ ...state, debugFavorites: enabled })),
  setDebugSSR: (enabled) => set((state) => ({ ...state, debugSSR: enabled })),
  setDebugAudio: (enabled) => set((state) => ({ ...state, debugAudio: enabled })),
  setDebugNotifications: (enabled) => set((state) => ({ ...state, debugNotifications: enabled })),
  
  resetDebugSettings: () => set(DEFAULT_DEBUG_STATE),
});